import React, { useState } from "react";
import Button from "@amzn/meridian/button";
import Column from "@amzn/meridian/column";
import Expander from "@amzn/meridian/expander";
import Text from "@amzn/meridian/text";
import PriceSection from "./priceSection";
import { prices } from "../constants/paths";
import { onClickPurchaseUrl } from "../utils/utils";
import Divider from "@amzn/meridian/divider";
import { FEATURES } from "../constants/messages";
import { useBundle } from "@amzn/react-arb-tools";
import { PRODUCTPAGE_MESSAGE_BUNDLE_NAME } from "src/constants";
import { t } from "src/helpers";

const EligibleProductText = ({ title, priceIndex, productIndex, url }) => {
  const [bundle] = useBundle(PRODUCTPAGE_MESSAGE_BUNDLE_NAME);
  const [open, setOpen] = useState();

  return (
    <Column spacing="500" alignmentVertical="justify">
      <Column heights="fill" spacing="400">
        <Text type="h400" fontFamily="bookerly">
          {title}
        </Text>
        <PriceSection price={prices[priceIndex]}></PriceSection>
      </Column>
      <Column>
        <Button type="primary" size="large" onClick={onClickPurchaseUrl(url)}>
          {t(bundle, "purchase_now")}
        </Button>
      </Column>
      <Expander
        open={open}
        onChange={setOpen}
        title={t(bundle, "see_product_criteria")}
        type="inline"
      >
        <Column spacing="300">
          {FEATURES.map(({ title, values }, index) => {
            const lines = values[productIndex].split("\n");
            return (
              <Column spacing="100">
                <Text type="h100">{t(bundle, title)}</Text>
                <Text type="b200">
                  {lines.map((line, lineIndex) => (
                    <React.Fragment key={lineIndex}>
                      {index < FEATURES.length - 1 ? (
                        <Text>{t(bundle, line)}</Text>
                      ) : (
                        <Text>{line}</Text>
                      )}
                      {lineIndex < lines.length - 1 && <br />}
                    </React.Fragment>
                  ))}
                </Text>
                {index < FEATURES.length - 1 && (
                  <Divider size="small"></Divider>
                )}
              </Column>
            );
          })}
        </Column>
      </Expander>
    </Column>
  );
};

export default EligibleProductText;
